import { SIGN_IN, SELECT_COMPANY, LOG_OUT, SELECTED_DATE, SELECTED_SCALE, LOADING_PREFERENCES } from "../constants";
import {connectSignalr} from './signalr.action';
import axios from "axios";


export const signIn = (form, showFn) => {
  return async (dispatch) => { 
      try {
        form.ModuleId = process.env.REACT_APP_MODULE_ID;
        form.AccessTypeId = 1;
        const { data } = await axios.post(process.env.REACT_APP_AUTH, form);

        if (data.Type === 1) {
          alert(data.Message);
          return;
        } else {
          dispatch({
            type: SIGN_IN,
            payload: data.Value,
          });
          showFn()
        }
      } catch (error) {
        console.error(error);
      }
  };
};




export const changeCompanyR = (company, history) => {
  return async (dispatch) => {
	localStorage.removeItem('company-s10');
	dispatch({
		type: SELECT_COMPANY,
		payload: {...company, change: true},
	});
  window.location.reload(false);
	// window.location.href = '/projects';
  };
};

export const selectCompany = (company, history) => {
  return async (dispatch) => {
	localStorage.removeItem('company-s10');
	dispatch(connectSignalr(company.Token));
	dispatch({
		type: SELECT_COMPANY,
		payload: company,
	});
	window.location.href = '/projects';
  };
};

export const logOut = (history) => {
	return async (dispatch) => {
	  dispatch({
		  type: LOG_OUT,
		});
		history.push("/");
	};
  };
  
export const SelectedDateFn = (date) => ({
  type: SELECTED_DATE,
  payload: date
})

  
export const setLoadingPreferences = (loading) => ({
  type: LOADING_PREFERENCES,
  payload: loading
})
  
export const selectedScaleFn = (date) => ({
  type: SELECTED_SCALE,
  payload: date
})
